export default class Scroll {

  static toTop() {
    $("body,html").animate({
      scrollTop: 0
    }, 300)
  }

  static toElement(elementId, data) {

    let wait = 100
    let duration = 300
    let offset = -50

    if (data) {
      wait = data.wait || wait
      duration = data.duration || duration
      offset = data.offset || offset
    }

    setTimeout(() => {

      $(document.body).scrollTo($(elementId), duration, { offset })

    }, wait)
  }
}
